<template>
  <div class="accounts">
    <h3>账户管理</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      v-loading="loading"
      size="mini"
    >
      <el-form-item label="用户ID">
        <el-input
          v-model.number="filter.userId"
          placeholder="用户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input v-model="filter.nickname" placeholder="用户昵称"></el-input>
      </el-form-item>
      <el-form-item label="用户电话">
        <el-input
          v-model="filter.phoneNumber"
          placeholder="用户电话"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button
          style="margin-left: 10px"
          type="primary"
          :disabled="loading_disabled"
          size="mini"
          @click="exportExcel()"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column
        prop="userId"
        width="120"
        label="用户ID"
      ></el-table-column>
      <el-table-column
        prop="nickname"
        width="240"
        label="用户昵称"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        width="140"
        label="用户手机号码"
      ></el-table-column>
      <el-table-column
        prop="depositAmount"
        label="充值账户余额"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="incomeAmount"
        label="收入账户余额"
        width="160"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="getToken(scope.row)"
            >查看资金账户</el-button
          >
        </template>
      </el-table-column>
      <div slot="append">
        <div class="footer_bottom">
          <div class="footer_left">当页合计金额</div>
          <div class="footer_bottom">
            <div class="footer_dep">
              <span class="txt-width">{{ totalNum.depositAmount }}</span>
            </div>
            <div class="footer_IncomeAmount">
              <span class="txt-width"> {{ totalNum.incomeAmount }}</span>
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          <div class="footer_left">汇总合计金额</div>
          <div class="footer_bottom">
            <div class="footer_dep">
              <span class="txt-width">{{ totalNum.totalDepositAmount }}</span>
            </div>
            <div class="footer_IncomeAmount">
              <span class="txt-width"> {{ totalNum.totalIncomeAmount }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-table>
    <br />
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../api";
const { account, order } = api;

export default {
  name: "accounts",
  data() {
    return {
      loading: false,
      loading_disabled: false,
      list: [],
      totalNum: {}, // 合计金额
      total: 0,
      pageNum: 1,
      limit: 20,
      filter: {
        userId: "",
        nickname: "",
        phoneNumber: "",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      this.loading = true;
      let { userId, nickname, phoneNumber } = this.filter;
      let obj = {
        userId: Number.isInteger(userId) ? userId : "",
        nickname,
        phoneNumber,
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let res = await account.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
      this.totalNum = res.data.statistics;
    },
    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
      if (data) {
        this.curData = data;
      } else {
        this.curData = {};
      }
    },
    async reject() {
      let obj = {
        invoiceId: this.curData.invoiceId,
        rejectRemark: this.rejectRemark,
      };
      if (!obj.rejectRemark) {
        this.$message.error("驳回原因不能为空");
        return false;
      }
      let {
        data: { code },
      } = await invoice.reject(obj);
      if (code == 200) {
        this.$message.success("操作成功");
        this.toggleDialog("reject");
        this.fetch();
      }
    },
    async confirm() {
      let obj = {
        invoiceId: this.curData.invoiceId,
        trackingNum: this.trackingNum,
      };
      if (!obj.trackingNum) {
        this.$message.error("快递单号不能为空");
        return false;
      }
      let {
        data: { code },
      } = await invoice.confirm(obj);
      if (code == 200) {
        this.$message.success("操作成功");
        this.toggleDialog("confirm");
        this.fetch();
      }
    },
    async getToken(row) {
      let obj = {
        userId: row.userId,
      };
      let {
        data: { code, data },
      } = await order.token(obj);
      if (code == 200) {
        let url = `${this.frontUrl}/funds?encrypt_code=${data}`;
        window.open(url, "_blank");
      }
    },
    async exportExcel() {
      this.loading = true;
      let obj = this.filter;
      let resp = await account.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("账户管理明细列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
  },
  mounted() {
    this.fetch(1);
  },
};
</script>
<style scoped>
.pagination {
  margin: 30px 0 10px;
  float: right;
}
.footer_bottom {
  height: 30px;
  display: flex;
  justify-self: flex-start;
  align-items: center;
}
.footer_dep {
  margin-left: 380px;
}
.txt-width {
  width: 200px;
  display: block;
}

.footer_left {
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/views/finance/accounts.vue